import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormLabel from "@material-ui/core/FormLabel";
import { useTranslation } from "react-i18next";
import { Controller, UseFormMethods } from "react-hook-form";

interface ICommunicationLanguage {
    control: UseFormMethods["control"];
    fieldsDisabled: boolean;
}
export const CommunicationLanguageRadio = (props: ICommunicationLanguage) => {
    const { t } = useTranslation(["customerDetails"]);
    const { control, fieldsDisabled } = props;
    return (
        <Controller
            control={control}
            name={"communicationLanguage"}
            render={(renderProps) => (
                <FormControl component="fieldset">
                    <FormGroup aria-label="position">
                        <FormLabel style={{ marginTop: "40px" }}>
                            {t("customerDetails:communicationLanguage")}
                        </FormLabel>
                        <RadioGroup
                            id={"communicationLanguage"}
                            name={renderProps.name}
                            value={renderProps.value}
                            onChange={(event) => {
                                return renderProps.onChange(event);
                            }}
                        >
                            <FormControlLabel
                                value="EL"
                                control={<Radio inputRef={renderProps.ref} />}
                                label={t("customerDetails:greek")}
                                disabled={fieldsDisabled}
                            />
                            <FormControlLabel
                                value="EN"
                                control={<Radio inputRef={renderProps.ref} />}
                                label={t("customerDetails:english")}
                                disabled={fieldsDisabled}
                            />
                        </RadioGroup>
                    </FormGroup>
                </FormControl>
            )}
        />
    );
};
